export default "__VITE_ASSET__DVd8tDGs__"